import React from "react";
import SvgIcon from '@material-ui/core/SvgIcon';

function PlaneIcon(props) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="18.016" height="18.192" viewBox="0 0 18.016 18.192" {...props}>
      <g id="Group_6265" data-name="Group 6265" transform="translate(0)">
        <path 
          id="Path_6397"
          data-name="Path 6397"
          d="M525.379,836.905c-5.347-2.622-10.741-5.85-15.206-7.579a1.37,1.37,0,0,0-1.828,1.314,45,45,0,0,0,1.138,6.371c3.185.192,6.38.472,9.576.759a.574.574,0,0,1,0,1.148c-3.175.285-6.348.563-9.512.755a45.406,45.406,0,0,0-1.2,6.374,1.365,1.365,0,0,0,1.829,1.315c4.465-1.729,9.857-4.956,15.205-7.579A1.551,1.551,0,0,0,525.379,836.905Z"
          transform="translate(-508.337 -829.245)"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
}

export default PlaneIcon;



// WEBPACK FOOTER //
// ./src/components/icons/PlaneIcon.jsx